module.exports = __webpack_public_path__ + "img/inscrire.5cbb6ed0.svg";